import { RegisterZReportHistory } from '../api/admin';
import Receipt from '../model/Receipt';
import { compareRegisterActivationDates } from './date';

export interface ReceiptRegisterSection {
  key: string;
  label: string;
  register?: Omit<RegisterZReportHistory, 'reports'>;
  receipts: Receipt[];
}

export const groupReceiptsByRegister = (
  receipts: Receipt[],
  registers: Omit<RegisterZReportHistory, 'reports'>[],
): ReceiptRegisterSection[] => {
  const sections: ReceiptRegisterSection[] = [...registers]
    .sort(compareRegisterActivationDates)
    .map((register) => ({
      key: `register-${register.registerKey}`,
      label: register.label || register.serial || register.registerKey,
      register,
      receipts: [],
    }));

  receipts.forEach((receipt) => {
    const matches = sections.filter(
      ({ register }) =>
        register &&
        (receipt.controlUnitSerial
          ? register.controlUnitSerial === receipt.controlUnitSerial
          : !!receipt.cashRegisterLabel && register.label === receipt.cashRegisterLabel),
    );
    let section = matches.length === 1 ? matches[0] : undefined;
    if (!section) {
      const key = `unmatched-${JSON.stringify([
        receipt.controlUnitSerial || '',
        receipt.cashRegisterLabel || '',
      ])}`;
      section = sections.find((candidate) => candidate.key === key);
      if (!section) {
        section = {
          key,
          label: receipt.cashRegisterLabel || receipt.controlUnitSerial || 'Utan kassaregister',
          receipts: [],
        };
        sections.push(section);
      }
    }
    section.receipts.push(receipt);
  });

  sections.forEach((section) => {
    const timestamp = (receipt: Receipt) =>
      Date.parse(receipt.dateCreated || receipt.datePaid) || 0;
    section.receipts.sort((a, b) => timestamp(b) - timestamp(a));
  });
  return sections;
};
